module.exports = __webpack_public_path__ + "static/media/agentconsle.bc31ce48.avif";